import { apiClient, type ApiClientResponse, routes } from 'common/services';

type EventFeedbackRequestData = {
  helpful_rating: boolean;
  audio_rating: boolean;
  video_rating: boolean;
};

export const createEventFeedback = async (id: string, data: EventFeedbackRequestData) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.events.createFeedback(id), {
    events_feedback: data,
  });
